import CommunicationSetting from './CommunicationSetting.component';

export default CommunicationSetting;